import { render } from "./StaffFAQ.vue?vue&type=template&id=da7145f6&scoped=true"
import script from "./StaffFAQ.vue?vue&type=script&lang=js"
export * from "./StaffFAQ.vue?vue&type=script&lang=js"

import "./StaffFAQ.vue?vue&type=style&index=0&id=da7145f6&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da7145f6"]])

export default __exports__